export default {"src":"/_next/static/media/coinbase.c4a8efe6.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};